var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6384 7.00697C17.4353 6.78586 17.2201 6.57072 16.993 6.36155L16.6434 3.91434C15.9514 3.51469 15.21 3.2073 14.4382 3L12.4572 4.48805C12.153 4.46115 11.847 4.46115 11.5428 4.48805L9.56175 3C8.79029 3.20826 8.04906 3.5156 7.35657 3.91434L7.00697 6.36155C6.78586 6.57072 6.57072 6.78586 6.36155 7.00697L3.91434 7.35657C3.51469 8.04861 3.2073 8.78996 3 9.56175L4.48805 11.5428C4.46116 11.8476 4.48805 12.4572 4.48805 12.4572L3 14.4382C3.20826 15.2097 3.5156 15.9509 3.91434 16.6434L6.36155 16.993C6.57072 17.2141 6.78586 17.4293 7.00697 17.6384L7.35657 20.0857C8.04861 20.4853 8.78996 20.7927 9.56175 21L11.5428 19.512C11.847 19.5389 12.153 19.5389 12.4572 19.512L14.4382 21C15.2097 20.7917 15.9509 20.4844 16.6434 20.0857L16.993 17.6384C17.2171 17.4323 17.6384 16.993 17.6384 16.993L20.0857 16.6434C20.4853 15.9514 20.7927 15.21 21 14.4382L19.512 12.4572C19.5388 12.1524 19.512 11.5428 19.512 11.5428L21 9.56175C20.7917 8.79029 20.4844 8.04906 20.0857 7.35657L17.6384 7.00697Z",
    stroke: "#EFEFEF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.5C13.933 15.5 15.5 13.933 15.5 12C15.5 10.067 13.933 8.5 12 8.5C10.067 8.5 8.5 10.067 8.5 12C8.5 13.933 10.067 15.5 12 15.5Z",
    stroke: "#EFEFEF",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingProfile);
export default __webpack_public_path__ + "static/media/settingProfile.0c77655353de301c5cc6917a0b812faf.svg";
export { ForwardRef as ReactComponent };